module.exports = __webpack_public_path__ + "static/media/edit-image.5885f2ae.svg";